import { useSelector } from 'react-redux';

import { videoFolderSelectors } from '../../../../store/modules/videoFolder';
import NotFoundFolder from '../../ProjectFolderBlock/NotFoundFolder';
import { isNotFoundErrorCode } from '../helpers';

export default () => {
  const error = useSelector(videoFolderSelectors.selectCurrentFolderError);
  const isError = isNotFoundErrorCode(error);

  const NotFoundOrNull = () => (isError ? <NotFoundFolder /> : null);

  return [isError, NotFoundOrNull] as const;
};
